import { render, staticRenderFns } from "./videoAi.vue?vue&type=template&id=8c75cbda&scoped=true"
import script from "./videoAi.vue?vue&type=script&lang=js"
export * from "./videoAi.vue?vue&type=script&lang=js"
import style0 from "./videoAi.vue?vue&type=style&index=0&id=8c75cbda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c75cbda",
  null
  
)

export default component.exports